import { defineStore } from "pinia";
import {
    CheckoutStage,
    CheckoutStages,
    CheckoutStep,
    CheckoutSteps,
} from "../../../services/models/checkout.models";
import { LineItemModel } from "Scripts/global/apps/utils/API/Cart/cartAPISchema";

export const useCheckoutStateStore = defineStore("checkoutState", {
    state: () => ({
        currentCheckoutStep: CheckoutSteps.CustomerInformation as CheckoutStep,
        currentCheckoutStage: CheckoutStages.InitialPageLoad as CheckoutStage,
        isLoadingCart: false,
        isLoading: false,
        receiptPageUrl: "",
        netsEasyApiCheckoutKey: "",
        paymentId: "",
        newItemsAfterVerification: null as null | Array<LineItemModel>,
    }),
    actions: {
        setIsLoading(isLoading: boolean) {
            this.isLoading = isLoading;
        },
        setIsLoadingCart(isLoadingCart: boolean) {
            this.isLoadingCart = isLoadingCart;
        },
        setCheckoutStage(stage: CheckoutStage) {
            this.currentCheckoutStage = stage;
        },
        setCheckoutStep(step: CheckoutStep) {
            this.currentCheckoutStep = step;
        },
        setNewItemsAfterVerification(items) {
            this.newItemsAfterVerification = items;
        },
        setReceiptPageUrl(receiptPageUrl: string) {
            this.receiptPageUrl = receiptPageUrl;
        },
        setNetsEasyApiCheckoutKey(netsEasyApiCheckoutKey: string) {
            this.netsEasyApiCheckoutKey = netsEasyApiCheckoutKey;
        },
        setPaymentId(paymentId: string) {
            this.paymentId = paymentId;
        },
    },
});
